import { render } from "./Delete.vue?vue&type=template&id=9473a642&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9473a642"

export default script